import React from 'react'
import { injectState } from 'freactal'
import { IconButton } from 'react-mdl'
import ScrollingDialog from '../../../../components/ScrollingDialog'
import { titleCase } from 'change-case'
import styled from 'styled-components'

import LearnerGuideContent from './LearnerGuideContent'
import FormativeTheoryContent from './FormativeTheoryContent'
import SummativeTheoryContent from './SummativeTheoryContent'
import FormativePracticalContent from './FormativePracticalContent'
import SummativePracticalContent from './SummativePracticalContent'

const Table = styled.table`
  width: 100%;
  tr td:first-child,
  tr th:first-child {
    width: 10%;
  }
`

function MappingModal({
  match: { params: { contentType, mappingType, mappingIndex } },
  history,
}) {
  const unitElement = {
    type: mappingType,
    index: mappingIndex.split('.').map(num => parseInt(num, 10)),
  }
  const headers = {
    'learner-guide': ['Mapped', 'Section Index', 'Section Name'],
    'formative-theory': ['Mapped', 'Question', 'Section Index'],
    'summative-theory': ['Mapped', 'Question', 'Section Index'],
    'formative-practical': ['Mapped', 'Task Number', 'Task Name'],
    'summative-practical': ['Mapped', 'Task Number'],
  }[contentType]

  const TableContents = () => {
    switch (contentType) {
      case 'formative-theory':
        return <FormativeTheoryContent unitElement={unitElement} />
      case 'summative-theory':
        return <SummativeTheoryContent unitElement={unitElement} />
      case 'formative-practical':
        return <FormativePracticalContent unitElement={unitElement} />
      case 'summative-practical':
        return <SummativePracticalContent unitElement={unitElement} />
      case 'learner-guide':
      default:
        return <LearnerGuideContent unitElement={unitElement} />
    }
  }

  return (
    <div>
      <ScrollingDialog title={`${titleCase(contentType)} Mapping`}>
        <IconButton
          style={{ position: 'absolute', top: 0, right: 0 }}
          name="close"
          onClick={history.goBack}
        />
        <Table>
          <thead>
            <tr>
              {headers.map((header, i) =>
                <th key={`header-${i}`}>
                  {header}
                </th>,
              )}
            </tr>
          </thead>
          <TableContents />
        </Table>
      </ScrollingDialog>
    </div>
  )
}
export default injectState(MappingModal)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/MappingModal/index.js